import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function SiteLayout() {
  const { pathname, hash } = useLocation();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <Outlet />
      </main>
      <SiteFooter />

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-900 text-background-50 transition-colors hover:bg-foreground-800 cursor-pointer"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-xl leading-none"></i>
        </button>
      )}
    </div>
  );
}